import Select from '@mui/material/Select';

type EnhancedSelectProps = {
  label?: string;
  isMultiple?: boolean;
  id?: string;
  labelId?: string;
  value?: '' | string[];
  onChange?: (...args: any[]) => any;
  renderValue?: (selected: string[]) => React.ReactNode;
  children?: React.ReactNode;
};

export default function EnhancedSelect({
  value,
  onChange,
  label,
  isMultiple = false,
  id,
  labelId,
  children,
  ...props
}: Readonly<EnhancedSelectProps>) {
  return (
    <Select
      labelId={labelId}
      id={id}
      multiple={isMultiple}
      label={label}
      value={value}
      onChange={(e) => onChange(e)}
      sx={{ width: '100%' }}
      {...props}
    >
      {children}
    </Select>
  );
}
